import { createResource } from 'redux-rest-resource';
import { HEADERS as headers, CONTACTS_URL } from '../../Constants';
import { transformFetchResponse as transformResponse } from '../../Helpers';

export const { types, actions, reducers } = createResource({
  name: 'contact',
  url: `${CONTACTS_URL}/:id`,
  headers,
  actions: {
    fetch: {
      transformResponse,
    },
  },
});
